import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { IconComponent } from '@shared-lib/components/icon/icon.component';
import { AdviserContactDetails } from '@shared/models/adviser-contact-details.model';
import { selectIsExperianCompany } from '@shared/store/common.selectors';
import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'cp-adviser-info',
  imports: [IconComponent, NgOptimizedImage, ButtonDirective, AsyncPipe],
  templateUrl: './adviser-info.component.html',
  styleUrl: './adviser-info.component.scss',
})
export class AdviserInfoComponent {
  @Input() adviserInfo: AdviserContactDetails;
  @Input() showContactCTAs = true;

  protected readonly globalStore = inject(Store);

  protected readonly isExperianCompany$ = this.globalStore.select(selectIsExperianCompany);
}
